"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationsListComponent = /** @class */ (function () {
    function NotificationsListComponent() {
    }
    return NotificationsListComponent;
}());
exports.NotificationsListComponent = NotificationsListComponent;
